import { Badge } from '@sequencehq/core-components'
import {
  isDisplayableCreditNoteApplicationStatus,
  toCreditNoteApplicationStatusBadgeProps,
  toCreditNoteStatusBadgeProps
} from '@sequencehq/utils'
import {
  CreditNoteApplicationStatus,
  CreditNoteStatus
} from 'CreditNotes/types'

interface Props {
  status: CreditNoteStatus
  applicationStatus?: CreditNoteApplicationStatus
}

export const CreditNoteStatusBadge = ({ status, applicationStatus }: Props) => (
  <>
    <Badge {...toCreditNoteStatusBadgeProps({ status })} />
    {isDisplayableCreditNoteApplicationStatus(applicationStatus) && (
      <Badge
        truncate
        {...toCreditNoteApplicationStatusBadgeProps({
          status: applicationStatus
        })}
      />
    )}
  </>
)
